/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_NotificationsInputs */

const en_us2_profile_why_notifications = /** @type {(inputs: Profile_Why_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout reminders, the summary after a session and the morning check-in.`)
};

const pt_br2_profile_why_notifications = /** @type {(inputs: Profile_Why_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembretes de treino, o resumo depois da sessão e o check-in da manhã.`)
};

const es_419_profile_why_notifications = /** @type {(inputs: Profile_Why_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordatorios de entrenamiento, el resumen después de la sesión y el check-in de la mañana.`)
};

const pt_pt2_profile_why_notifications = /** @type {(inputs: Profile_Why_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembretes de treino, o resumo depois da sessão e o check-in da manhã.`)
};

const fr_fr2_profile_why_notifications = /** @type {(inputs: Profile_Why_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rappels d'entraînement, résumé après la séance et bilan du matin.`)
};

const de_de2_profile_why_notifications = /** @type {(inputs: Profile_Why_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingserinnerungen, die Zusammenfassung nach einer Einheit und der Morgen-Check-in.`)
};

const it_it2_profile_why_notifications = /** @type {(inputs: Profile_Why_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promemoria di allenamento, il riepilogo dopo la sessione e il check-in del mattino.`)
};

/**
* | output |
* | --- |
* | "Workout reminders, the summary after a session and the morning check-in." |
*
* @param {Profile_Why_NotificationsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_notifications = /** @type {((inputs?: Profile_Why_NotificationsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_NotificationsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_notifications(inputs)
	if (locale === "es-419") return es_419_profile_why_notifications(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_notifications(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_notifications(inputs)
	if (locale === "de-DE") return de_de2_profile_why_notifications(inputs)
	if (locale === "it-IT") return it_it2_profile_why_notifications(inputs)
	return en_us2_profile_why_notifications(inputs)
});
export { profile_why_notifications as "profile.why_notifications" }